import * as React from 'react';

import type {SignupStartPage} from '../types';

import styles from './signup-form.module.css';
import {SignupCustomHeader} from './signup-custom-header';

type Props = {
    signupStartPage: SignupStartPage;
};

export function SignupStartPageHeader(props: Props) {
    switch (props.signupStartPage) {
        case 'ZENDESK_SELL':
            return (
                <SignupCustomHeader
                    imgSrc={'/client-resources/zendesksell_logo.png'}
                    officialPartner={false}
                />
            );
        case null:
            return null;
        default:
            // Exhaustiveness check: https://flow.org/en/docs/types/empty/
            props.signupStartPage as never;

            return null;
    }
}
